import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  return (
  <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        Mon<strong className="purple"> Calendrier</strong>
      </h1>
      <GitHubCalendar
        username="Ahlan06"
        blockSize={15}
        blockMargin={5}
        color="#c084f5"
        fontSize={16}
        key={`calendar-${Math.random()}-${Date.now()}`}
        year={2025}
      />
    </Row>
  );
}

export default Github;
